module.exports = __webpack_public_path__ + "static/media/27.5090a2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/27.jpg
// module id = 288
// module chunks = 0